import { hidePiiData as e } from "../hidePiiData.js";
//#region src/utils/init/initPiiObserver.ts
var t = "shuffle", n = "mask", r = "reset", i = "data-pii", a = "data-original-pii", o = "data-hide-pii", s = "data-obfuscated-pii", c = "[data-pii=\"visible\"]", l = () => {
	let l = document.documentElement, u = null, d = !1, f = () => {
		let t = l.querySelectorAll(c);
		for (let n of t) e(n);
	}, p = () => {
		let t = l.querySelectorAll("[data-pii=\"hidden\"][data-original-pii]");
		for (let n of t) {
			let t = n.getAttribute(a);
			e(n, String(t)), n.removeAttribute(a), n.removeAttribute(s), n.setAttribute(i, "visible");
		}
	}, m = () => {
		u || (u = new MutationObserver((r) => {
			let a = l.getAttribute(o);
			if (a === t || a === n) {
				for (let t of r) if (t.type === "childList") {
					for (let n of t.addedNodes) if (n.nodeType === Node.ELEMENT_NODE) {
						let t = n;
						t.matches(c) && e(t);
						let r = t.querySelectorAll(c);
						for (let t of r) e(t);
					}
				} else if (t.type === "attributes" && t.attributeName === i) {
					let n = t.target;
					n.getAttribute(i) === "visible" && e(n);
				}
			}
		}), u.observe(document.body, {
			subtree: !0,
			childList: !0,
			attributes: !0,
			attributeFilter: [i]
		}));
	}, h = () => {
		u &&= (u.disconnect(), null);
	};
	new MutationObserver((t) => {
		let n = (t) => {
			let n = t.getAttribute(i) === "hidden", r = t.getAttribute(s), o = t.getAttribute(a);
			if (!r || !o || !n) return;
			let c = t instanceof HTMLInputElement ? t.value ?? "" : t.textContent ?? "";
			(c === o || c !== r) && e(t, r);
		};
		for (let e of t) {
			if (e.type === "childList") {
				for (let t of e.addedNodes) if (t instanceof Element) {
					n(t);
					let e = t.querySelectorAll("[data-obfuscated-pii][data-original-pii]");
					for (let t of e) n(t);
				}
			}
			if (e.type === "attributes") {
				let t = e.target;
				n(t);
			}
			if (e.type === "characterData") {
				let t = e.target.parentElement;
				t?.matches("[data-pii=\"hidden\"][data-obfuscated-pii][data-original-pii]") && n(t);
			}
		}
		g();
	}).observe(document.body, {
		subtree: !0,
		childList: !0,
		attributes: !0,
		characterData: !0,
		attributeFilter: [
			s,
			a,
			i,
			"value"
		]
	});
	let g = () => {
		let t = document.body.querySelectorAll("[data-obfuscated-pii][data-original-pii]");
		for (let n of t) {
			let t = n.getAttribute(a), r = n.getAttribute(s);
			v(n) === t && e(n, String(r));
		}
	}, _ = () => {
		let e = l.getAttribute(o), n = e === t, i = e === r;
		!n && d && (h(), d = !1), i && p(), n && !d && (m(), d = !0, f(), g());
	};
	new MutationObserver(_).observe(l, {
		attributes: !0,
		attributeFilter: [o]
	}), _();
	let v = (e) => e instanceof HTMLInputElement ? e.value : e.textContent ?? "";
	document.addEventListener("keydown", (e) => {
		if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === "u") {
			let e = l.getAttribute(o);
			e === t ? l.setAttribute(o, n) : e === n ? l.setAttribute(o, r) : l.setAttribute(o, t);
		}
	});
};
//#endregion
export { l as initPiiObserver };

//# sourceMappingURL=initPiiObserver.js.map